/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\EngagementSVG\Serenity.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday April 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday April 17th 2023 2:41:52 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function Serenity(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M141.46,390.06c12.63-63.9,24.03-125.43,37.16-186.6,9.44-44.03,35.39-56,75.47-33.92,49.81,27.45,99.54,55.05,152.34,84.27,20.11-27.84,40.02-57.44,61.99-85.43,66.04-84.17,77.34-84.36,142.56-2.11,22.31,28.13,42.37,58.05,63.52,87.23,52.82-28.88,104.2-56.97,155.57-85.06,38.33-20.96,62.77-8.01,71.71,32.53,13.86,62.86,25.38,126.24,37.82,188.99,29.54,0,59.66-.47,89.77,.13,31.97,.63,49.4,15.98,48.76,49.65-5.71,296.76-138.56,485.43-436.69,515.88-102.1,10.43-211.16,1.94-310.8-22.93C117.08,879.39-24.17,655.67,4.75,436.52c2.26-17.17,27.13-39.6,45.5-44.48,28.32-7.53,60.12-1.98,91.21-1.98Zm399.62,475.31c185.43-178.4,185.16-494.34-.57-662.47-186,170.99-185.73,488.98,.57,662.47ZM82.42,452.87c-11.31,250.13,137.02,416.92,371.69,429.05-73.57-104.29-121.91-213.95-130.54-338.56-.76-10.92-16.78-26.32-28.7-30.03-67.99-21.12-136.88-39.32-212.45-60.47Zm546.87,427.12c232.03-4.41,382.07-182.41,367.28-426.86-73.29,20.83-143.83,40.06-213.65,61.61-10.41,3.21-24.43,16.9-25.01,26.45-7.6,125.17-57.04,234.71-128.62,338.79Zm123.69-433.94c37.69-13.63,71.53-25.85,111.74-40.39-7.12-52.18-14.17-103.87-21.45-157.31-134.45,47.89-142.55,66.4-90.28,197.7ZM239.03,244.08c-8.17,56.9-15.61,108.75-23.24,161.87,41.35,14.56,76.64,26.99,111.71,39.35,54.31-124.59,50.6-133.9-88.47-201.22Z"/>
        </svg>
    );
}

export default Serenity;
